import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface AddressType {
    id: number;
    addressTypeName: string;
    isActive: boolean;
    auditTrailId: number | null;
}

interface AddressTypesState {
    data: AddressType[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const MASTERURL = import.meta.env.VITE_API_USERS_URL;

// Diet Mapping Code
export const fetchAddressType = createAsyncThunk<AddressType[], void, { rejectValue: string }>(
    'AddressType/fetchAddressType',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: AddressType[] }>('/get_all_address_type', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createAddressType = createAsyncThunk<AddressType, any, { rejectValue: string }>(
    'AddressType/createAddressType',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: AddressType }>('create_address_type', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateAddressType = createAsyncThunk<AddressType, any, { rejectValue: string }>(
    'AddressType/updateAddressType',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: AddressType }>('update_address_type', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const AddressTypeSlice = createSlice({
    name: 'AddressType',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as AddressTypesState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchAddressType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAddressType.fulfilled, (state, action: PayloadAction<AddressType[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAddressType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createAddressType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAddressType.fulfilled, (state, action: PayloadAction<AddressType>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createAddressType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateAddressType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAddressType.fulfilled, (state, action: PayloadAction<AddressType>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateAddressType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default AddressTypeSlice.reducer;